import React, { Component } from "react";
import Global from "../../Global";

import "./TravelSimPlan.css";
import ArrowLeftWhite from "../../svgs/arrow-left-white.svg";
import ArrowRightWhite from "../../svgs/arrow-right-white.svg";

class TravelSimPlan extends Component {
  constructor(props) {
    super(props);

    this.state = {
	  plansArray:[],
	  currentPagePlans:[],
	  pagesize:5,
	  pageIndex:1,
	  pageX:null,
	  pageY:null,
      data: {
        general: null,
        items: null
      },
	  leftClickFlag:true,
	  rightClickFlag:true
    };
	
	this.prevPage = this.prevPage.bind(this);
	this.nextPage = this.nextPage.bind(this);
  }

  componentWillMount() {
    var url = Global.getAPI("travel-sim-plan");
    var self = this;
    fetch(url)
      .then(function(response) {
        if (response.status >= 400) {
          throw new Error("Error API: travel-sim-plan");
        }
        return response.json();
      })
      .then(function(data) {
        self.setState(
          {
            data: data
          },
          function() {
            this.resetPages()
          }
        );
      });

    window.addEventListener("resize", this.resetPages.bind(this));
  }

  //初始化 &重置 分页数据
  resetPages() {
	if(document.body.clientWidth < 1000){
		document.getElementById("mobile-plan-list-div").setAttribute("style","height:auto");
		document.getElementById("plan-list-div").setAttribute("style","display:none");
		document.getElementById("page-div").setAttribute("style","display:none");
	}else{
		document.getElementById("mobile-plan-list-div").setAttribute("style","height:0px");
		document.getElementById("plan-list-div").setAttribute("style","display:inline-block");
		document.getElementById("page-div").setAttribute("style","display:inline-block");
	}
	  
	  
	var arr = new Array()
	Object.keys(this.state.data.items).map( (key) => {
		arr.push(this.state.data.items[key]);
	})

	this.setState({
		plansArray: arr,
		pageIndex:1,
		pagesize:5
	})

	var currentPagePlans = new Array()
	if(arr.length > this.state.pagesize){
		for(let i=0;i<5;i++){
			currentPagePlans.push(arr[i])
		}
		this.setState({
			currentPagePlans
		},()=>{
			document.getElementById("page-0").setAttribute("class","page page-active");
		})
	}else{
		this.setState({
			currentPagePlans: arr
		},()=>{
			document.getElementById("page-0").setAttribute("class","page page-active");
		})
	}
  }
  //手机页面下获取plan列表
  // getMobilePlanList(){
	// return this.state.plansArray.map( ( obj, index ) =>
	//   (obj.newPrice == '' || typeof (obj.newPrice) == 'undefined') ?
	//   	(<div key={index} className="plan">
	//   		<img src={ obj.image } />
	//   		<span className={"labelSpan"}>{ (obj.label !== "" && obj.descr !== "") ? obj.label : "\u00A0"}</span>
	//   		<span className={"descSpan"}>{ (obj.label !== "" && obj.descr !== "") ? obj.descr : "\u00A0"}</span>
	//   		<span className="price">{ obj.price }</span>
	//   	</div>)
	//   : (<div key={index} className="plan">
	//   		<img src={ obj.image } />
	//   		<span className={"labelSpan"}>{ obj.label }</span>
	//   		<span className={"descSpan"}>{ obj.descr }</span>
	//   		<span className="price"><i className="new-price">{ obj.newPrice }</i><i className="old-price">{ obj.price }</i></span>
	//   	</div>)
	// )
  // }

  //获取plan列表
  getPlanList(){
  	let pagePlans = this.state.currentPagePlans;

  	let blankSize = 0;
  	let totalSize = pagePlans.length;

  	pagePlans.forEach((o) => {
  		if(o.label === ""){
  			blankSize++;
		}
	});

	return pagePlans.map((obj, index) => {
		let priceSpan = (<span className="price">{ obj.price }</span>);

		if(typeof(obj.newPrice) !== 'undefined' && obj.newPrice !== ""){
			priceSpan = (<span className="price"><i className="new-price">{ obj.newPrice }</i><i className="old-price">{ obj.price }</i></span>);
		}

		let labelSpan = (<React.Fragment></React.Fragment>);

		if(blankSize !== totalSize){
			let labelText = (obj.label !== "") ? obj.label : "\u00A0";
			labelSpan = (<span className={"labelSpan"}>{labelText}</span>);
		}

		return (
			<div key={index} className="plan" onClick={() => this.clickLink(obj.targetUrl)}>
				<img src={ obj.image } />
				{labelSpan}
				<span className={"descSpan"}>{ obj.descr }</span>
				{priceSpan}
			</div>
		);
	});

  	/*
	return this.state.currentPagePlans.map( ( obj, index ) =>
	(obj.newPrice == '' || typeof (obj.newPrice) == 'undefined') ?
		(<div key={index} className="plan" onClick={() => this.clickLink(obj.targetUrl)}>
			<img src={ obj.image } />
			<span className={"labelSpan"}>{ (obj.label !== "" && obj.descr !== "") ? obj.label : "\u00A0" }</span>
			<span className={"descSpan"}>{ (obj.label !== "" && obj.descr !== "") ? obj.descr : "\u00A0" }</span>
			<span className="price">{ obj.price }</span>
		</div>)
	: (<div key={index} className="plan" onClick={() => this.clickLink(obj.targetUrl)}>
			<img src={ obj.image } />
			<span className={"labelSpan"}>{ (obj.label !== "" && obj.descr !== "") ? obj.label : "\u00A0" }</span>
			<span className={"descSpan"}>{ (obj.label !== "" && obj.descr !== "") ? obj.descr : "\u00A0" }</span>
			<span className="price"><i className="new-price">{ obj.newPrice }</i><i className="old-price">{ obj.price }</i></span>
		</div>)
	)

  	 */
  }

  clickLink = (linkURL) => {
  	window.location.href = linkURL;
  }

  //获取分页数据
  getPage(){
	let pageCount = Math.ceil(this.state.plansArray.length / this.state.pagesize)
	let htmlArr = new Array();
	for(let i=0;i<pageCount;i++){
		htmlArr.push("page");
	}
	return htmlArr.map( ( obj, index ) =>
		<span key={index} className={obj} id={'page-'+index} onClick={this.jumpPage.bind(this,index)}></span>
	)
  }
  
  //跳转至指定分页
  jumpPage(pageIndex){
	  var fader = null;
	  var opacity = 1;
	  var flag = 10;
	  var planListObj = document.getElementById("plan-list");
	  var self = this;
	  fader = setInterval(function() {
	  	opacity = (opacity - 0.1).toFixed(1);
	  	flag -= 1;
	  	if (flag > 0) {
	  	    planListObj.style.opacity = opacity;
	  	} else if(flag === 0){
	  	    pageIndex = pageIndex + 1
	  	    let currentPagePlans = new Array();
	  	    
	  	    var maxCount;
	  	    if( pageIndex*self.state.pagesize > self.state.plansArray.length ){
	  	    	maxCount = self.state.plansArray.length;
	  	    	document.getElementById("plan-next-page").setAttribute("class","plan-right-icon disabled-icon");
	  	    }else{
	  	    	maxCount = pageIndex*self.state.pagesize;
	  	    	if(pageIndex === 1){
	  	    		document.getElementById("plan-prev-page").setAttribute("class","plan-left-icon disabled-icon")
	  	    		// document.getElementById("plan-next-page").setAttribute("class","plan-right-icon")
	  	    	}else{
	  	    		document.getElementById("plan-prev-page").setAttribute("class","plan-left-icon")
	  	    		document.getElementById("plan-next-page").setAttribute("class","plan-right-icon");
	  	    	}
	  	    }
	  	    
	  	    for(var i = (pageIndex - 1)*self.state.pagesize;i<maxCount;i++){
	  	    	currentPagePlans.push(self.state.plansArray[i])
	  	    }
	  	    
	  	    //分页索引样式
	  	    var pageObj = document.getElementsByClassName("page");
	  	    for(var i=0;i<pageObj.length;i++){
	  	    	pageObj[i].setAttribute("class","page")
	  	    }
	  	    document.getElementById("page-"+(pageIndex-1)).setAttribute("class","page page-active");
	  	    
	  	    self.setState({
	  	    	currentPagePlans,
	  	    	pageIndex
	  	    })
	  	}else if(flag > -11 && flag < 0 ){
	  		planListObj.style.opacity = (-opacity);
	  	}else{
	  		clearInterval(fader);
	  	   }
	  },50)
	
  }

  //上一页
  prevPage() {
	if( !document.getElementById("plan-prev-page").classList.contains("disabled-icon") ){
		if(this.state.leftClickFlag){//防止快速多次点击
			this.setState({
				leftClickFlag:false
			});
			var fader = null;
			var opacity = 1;
			var flag = 10;
			var planListObj = document.getElementById("plan-list");
			var self = this;
			fader = setInterval(function() {
				opacity = (opacity - 0.1).toFixed(1);
				flag -= 1;
				if (flag > 0) {
				    planListObj.style.opacity = opacity;
				} else if(flag === 0){
				    let pageIndex = self.state.pageIndex - 1;
				     
				    let currentPagePlans = new Array();
				    for(var i = (pageIndex-1)*self.state.pagesize;i<pageIndex*self.state.pagesize;i++){
				     	currentPagePlans.push(self.state.plansArray[i])
				    }
				     
				    self.setState({
				     	currentPagePlans,
				     	pageIndex
				    })
				     
				    //分页图标样式
				    if(pageIndex === 1){
				     	document.getElementById("plan-prev-page").setAttribute("class","plan-left-icon disabled-icon")
				     	document.getElementById("plan-next-page").setAttribute("class","plan-right-icon")
				    }else{
				     	document.getElementById("plan-prev-page").setAttribute("class","plan-left-icon")
				     	document.getElementById("plan-next-page").setAttribute("class","plan-right-icon")
				    }
				     
				    //分页索引样式
				    var pageObj = document.getElementsByClassName("page");
				    for(var i=0;i<pageObj.length;i++){
				     	pageObj[i].setAttribute("class","page")
				    }
				    document.getElementById("page-"+(pageIndex-1)).setAttribute("class","page page-active");
				}else if(flag > -11 && flag < 0 ){
					planListObj.style.opacity = (-opacity);
				}else{
					self.setState({
						leftClickFlag:true
					});
					clearInterval(fader);
				   }
			},50)
		}
		
	}
  }

  //下一页
  nextPage() {
	if( !document.getElementById("plan-next-page").classList.contains("disabled-icon") ){
		if(this.state.rightClickFlag){//防止快速多次点击
			this.setState({
				rightClickFlag:false
			});
			var fader = null;
			var opacity = 1;
			var flag = 10;
			var planListObj = document.getElementById("plan-list");
			var self = this;
			fader = setInterval(function() {
				opacity = (opacity - 0.1).toFixed(1);
				flag -= 1;
				if (flag > 0) {
					planListObj.style.opacity = opacity;
				}else if(flag === 0){
					let pageIndex = self.state.pageIndex + 1;
					let currentPagePlans = new Array();
					document.getElementById("plan-prev-page").setAttribute("class","plan-left-icon");
					var maxCount;
					if( pageIndex*self.state.pagesize > self.state.plansArray.length ){
						maxCount = self.state.plansArray.length;
						document.getElementById("plan-next-page").setAttribute("class","plan-right-icon disabled-icon")
					}else{
						maxCount = pageIndex*self.state.pagesize;
						document.getElementById("plan-next-page").setAttribute("class","plan-right-icon")
					}
					
					for(var i = self.state.pageIndex*self.state.pagesize;i<maxCount;i++){
						currentPagePlans.push(self.state.plansArray[i])
					}
					
					//分页索引样式
					var pageObj = document.getElementsByClassName("page");
					for(var i=0;i<pageObj.length;i++){
						pageObj[i].setAttribute("class","page")
					}
					document.getElementById("page-"+(pageIndex-1)).setAttribute("class","page page-active");
					
					self.setState({
						currentPagePlans,
						pageIndex
					})
				}else if(flag > -11 && flag < 0 ){
					planListObj.style.opacity = (-opacity);
				}else{
					self.setState({
						rightClickFlag:true
					});
					clearInterval(fader);
				   }
			},50)
		}
		
	}
  }
  
  mouseDown(e){
	   e.preventDefault();
	     var pageX=e.pageX;
	     var pageY=e.pageY;
		 this.setState({
		 	pageX,
		 	pageY
		 })
  } 
  
  mouseUp(e){
	  e.preventDefault();
	  var x = e.pageX;
	  var y = e.pageY;
	  if(x-this.state.pageX < -10){
		  this.nextPage()
	  }else if(x-this.state.pageX > 10){
		  this.prevPage()
	  }
  }
  
  

  render() {
    if (this.state.data.general === null || this.state.data.items === null) {
      return false;
    } else {
      return (
        <div id="travel-sim-plans" className="container">
          <div className="headline">
            <div className="blurb">
              <h4 class="title">{this.state.data.general.title}</h4>
              <h1 className="title-text">
                {this.state.data.general.description}
              </h1>
            </div>
          </div>
          <div className="more-plan-div">
              <a href={this.state.data.general.viewMoreUrl}>
                {this.state.data.general.viewMoreLabel}
              </a>
          </div>
          <div className="plan-list-div" id="plan-list-div">
            <img
              id="plan-prev-page"
              className="plan-left-icon disabled-icon"
              src={ArrowLeftWhite}
              onClick={this.prevPage.bind(this)}
            />
            <div className="plan-list" id="plan-list" onMouseDown={e => this.mouseDown(e)} onMouseUp={e => this.mouseUp(e)}>
              {this.getPlanList()}
            </div>
            <img
              id="plan-next-page"
              className="plan-right-icon"
              src={ArrowRightWhite}
              onClick={this.nextPage.bind(this)}
            />
          </div>
		  <div className="page-div" id="page-div">
				{this.getPage()}
		  </div>
		  <div className="mobile-plan-list-div" id="mobile-plan-list-div">
			  <div className="plan-list" id="mobile-plan-list">
				{ /*this.getMobilePlanList()*/ this.getPlanList()}
			  </div>
		  </div>
		  <div className="mobile-more-div">
			  <a href={this.state.data.general.viewMobileMoreUrl}>
				{this.state.data.general.viewMobileMoreLabel}
			  </a>
		  </div>
        </div>
      );
    }

  }
}

export default TravelSimPlan;
